export default __webpack_public_path__ + "static/char-s-46-ja-f19c10cf78b18379a28e957c283331ca.webp";